import React from 'react'
import Personne from './personne'
import "./trombinoscope.scss"
export default function Trombinoscope(props) {
    const {personnes} = props
    return (
        <div id="trombinoscope" className='flex between wrap'>
            {
                personnes.map((personne, index) => (
                    <Personne 
                        index={index}
                        key={index} 
                        picture={personne.picture} 
                        name={personne.name} 
                        fonction={personne.fonction} 
                        phone={personne.phone} 
                        mail={personne.mail}
                        left={personne.left}
                        right={personne.right}
                    />
                ))
            }
        </div>
    )
}
